import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const BackToTop = () => {
  const { isDarkMode } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`fixed bottom-8 right-8 z-40 p-2.5 rounded-lg shadow-lg transition-all duration-300 hover:scale-110 group ${
            isDarkMode
              ? 'bg-fsgu-gray-800 hover:bg-fsgu-green-500/20 border-2 border-fsgu-gray-700 hover:border-fsgu-green-500/50'
              : 'bg-fsgu-white hover:bg-fsgu-green-500/10 border-2 border-fsgu-silver-200 hover:border-fsgu-green-500/50'
          }`}
          aria-label="Back to top"
        >
          <ArrowUp
            className={`w-5 h-5 transition-all duration-300 ${
              isDarkMode
                ? 'text-fsgu-green-400 group-hover:text-fsgu-green-300'
                : 'text-fsgu-green-500 group-hover:text-fsgu-green-600'
            }`}
          />
        </button>
      )}
    </>
  );
};

export default BackToTop;